// Actions constants should be mapped in the same order
// as they are defined in the actions file.
export const ACTIONS = {
  SET_LOGIN_SUCCESS: 'set_login_success',
  SET_USER_LOGIN: 'set_user_login',
  SET_PARTY_UID: 'set_party_uid',
  CLEAR_AUTH: 'clear_auth'
};
